export default "__VITE_ASSET__ec9d1971__"